export const PAGE_MOBILE = {
  TITLE: 0,
  LOADING: 1,
  INTRO: 2,
  PROJECTS: 3,
  REACH: 4,
}
